// @flow
import * as React from 'react';
import { Box, Button } from 'grommet';
import { ThemeContext } from 'styled-components';


type Props = {
    onClick: Function,
    selected?: boolean,
    icon?: React.ComponentType<*>,
    children?: React.Node,
    Button: React.ComponentType<Button>,
    buttonProps?: Object,
    iconProps?: Object,
    disabled?: boolean,
};

const HeaderButton = (props: Props) => {
    const {
        onClick, selected, icon: IconCmp, children, Button: ButtonCmp, buttonProps, iconProps, disabled,
    } = props;
    const theme = React.useContext(ThemeContext);

    return (
        <ButtonCmp
            size="medium"
            onClick={onClick}
            style={{
                height: '60px',
                width: '60px',
                backgroundColor: selected ? theme.global.colors.navigation : 'white',
            }}
            hoverIndicator={!selected && !disabled ? '#ecedef !important' : ''}
            {...buttonProps}
        >
            <Box align="center" justify="center" style={{ position: 'relative' }} height="60px">
                {IconCmp && (
                    <IconCmp
                        style={{ height: '32px', width: '32px' }}
                        {...iconProps}
                    />
                )}
                {children}
            </Box>
        </ButtonCmp>
    );
};

HeaderButton.defaultProps = {
    selected: false,
    icon: undefined,
    children: undefined,
    Button,
    buttonProps: {},
    iconProps: {},
    disabled: false,
};

export default HeaderButton;
